export const environment = {
  env: 'dev',
  apiUrl: 'https://api-test.inspect.jujotech.com/api',
  aiUrl: 'https://wfeditor-test.inspect.jujotech.com',
  accessToken: 'XrT0kxC8_VPRxyI2bkn4Ds6WmOlj9YaT2RfQ8pTmQ6k',
  production: false,
  oneDrive: {
    appId: '7edf852e-a70f-4250-9197-bcec426b19f7',
    scopes: [
      'Files.ReadWrite.All',
      'user.read',
    ]
  },
  appVersion: 'v1.0.2',
  spAuthUri: 'https://auth-test.j4ria.jujotech.com',
  spAuthClientId: '58097fa4-322b-11f0-8975-0022480863ae',
  spAuthRedirectUri: 'https://wfeditor-test.inspect.jujotech.com/oauth/callback'
};
